import { classNames } from '~/utils/classNames';
import { socialLinks } from '~/utils/socialLinks';

export const HeaderSocialLinks = () => {
  const filteredSocialLinks = socialLinks.filter((item) => item.displayInHeader);

  return (
    <div className="inline-flex items-center gap-3">
      {filteredSocialLinks.map(({ icon, href, name }, index) => {
        return (
          <a
            data-icon={icon}
            key={index}
            href={href}
            className={classNames(
              `${icon} text-bolt-elements-textSecondary text-[22px] hover:text-bolt-elements-textPrimary`,
              { 'text-[24px]': name === 'Discord', 'text-[18px]': name === 'LinkedIn' },
            )}
            target="_blank"
          />
        );
      })}
    </div>
  );
};
